import React from 'react'
import CardGranularStep from './CardGranularStep'
import DialogEvidenceOfLearning from './DialogEvidenceOfLearning'
import LcElemensCards from '../../../../../card/LcElemensCards'
import CurriculumElementsCards from '../../../../../card/CurriculumElementsCards'
import ScrollToBottom from 'react-scroll-to-bottom'

const GranularStepsPreview = ({ lcs = [], completed, currentCurriculum, learningGrowth = [], type }) => {
  const [modal, setModal] = React.useState(null)
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {}
  const maxMarking = currentCurriculum?.marking?.find((item) => item.maxValue) || {}

  const lcsElements = {}
  let levelsId = []
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId)
    levelsId = [...levelsId, ...lvls]
  })

  levelsId = [...new Set(levelsId)]
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position)

  return (
    <ScrollToBottom className='w-full h-full' followButtonClassName='z-20'>
      <div className={['py-1 flex flex-col gap-1', lcs.length > 3 ? 'w-fi' : 'w-auto'].join(' ')}>
        {levelsRender?.map((item, index) => (
          <React.Fragment key={`granular-steps-level-${item._id}-${index}`}>
            <CardGranularStep
              completed={completed}
              lcs={lcs}
              levelId={item._id}
              level={{
                ...item,
                primaryColor: minMarking?.primaryColor,
                secondaryColor: minMarking?.secondaryColor,
                levelIndex: index
              }}
              nextLevel={levelsRender[index - 1]}
              marking={currentCurriculum.marking || []}
              minMarking={minMarking}
              maxMarking={maxMarking}
              onEvidenceOfLearning={(form) =>
                setModal({ type: 'evidence-of-learning', form, action: 'preview' })
              }
              onNote={(form) => setModal({ type: 'note', form, action: 'preview' })}
              learningGrowth={learningGrowth}
              type={type}
            />
          </React.Fragment>
        ))}
        <LcElemensCards
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
          classUlInfo={true}
        />
        <CurriculumElementsCards
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
          classUlInfo={true}
        />
        {modal && (
          <DialogEvidenceOfLearning
            open={!!modal?.type}
            onClose={() => setModal(null)}
            formData={modal?.form}
            type={modal?.type}
          />
        )}
      </div>
    </ScrollToBottom>
  )
}

export default GranularStepsPreview
